
// Import the supabase client from the central location
import { supabase } from '@/integrations/supabase/client';

// Public URL for the whitelist proofs JSON file
export const WHITELIST_PROOFS_URL = `https://zvvnbczckdevzzgexncb.supabase.co/storage/v1/object/public/proofs/whitelist-proofs-2025-05-15T15-18-51.267Z.json`;

// Function to test Supabase connection
export const testSupabaseConnection = async () => {
  console.log('📡 Testing Supabase connection...');
  try {
    const { data, error } = await supabase
      .from('initiated_bros')
      .select('*')
      .limit(1);
    
    if (error) {
      console.error('🔴 Supabase connection test failed:', error);
      return false;
    }
    
    console.log('✅ Supabase connection successful! Sample data:', data);
    return true;
  } catch (e) {
    console.error('🔴 Supabase connection exception:', e);
    return false;
  }
};

// Get whitelist proofs
export async function getWhitelistProofs() {
  try {
    console.log('📄 Fetching whitelist proofs from:', WHITELIST_PROOFS_URL);
    
    // First try to fetch directly from the public URL
    const response = await fetch(WHITELIST_PROOFS_URL);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch whitelist proofs: ${response.status}`);
    }
    
    const proofs = await response.json();
    console.log('✅ Successfully loaded whitelist proofs, entries:', Object.keys(proofs).length);
    
    // Ensure all address keys are lowercase
    const normalizedProofs: Record<string, any> = {};
    Object.keys(proofs).forEach(key => {
      normalizedProofs[key.toLowerCase()] = (proofs as any)[key];
    });
    
    return normalizedProofs;
  } catch (error) {
    console.error('❌ Error fetching whitelist proofs:', error);
    return null;
  }
}

export function getMerkleProofForAddress(proofs: any, address: string) {
  if (!proofs || !address) {
    console.log('Missing proofs or address');
    return null;
  }
  
  // Convert address to lowercase for consistency
  const normalizedAddress = address.toLowerCase();
  console.log('Looking for proof for address:', normalizedAddress);
  
  // Check if the address exists in the proofs
  const hasProof = normalizedAddress in proofs;
  console.log('Address has proof:', hasProof);
  
  // Return the proof for the address if it exists
  return proofs[normalizedAddress] || null;
}

// Export supabase client for backward compatibility
export { supabase };

// Call the test on load
testSupabaseConnection();
